import { Grid, Theme, Tooltip, useMediaQuery } from "@mui/material"
import { useContext } from "react"
import { AppContext } from "../../../store/context"
import React from "react"
import { useHistory } from "react-router-dom"
import OperationButtonContained from "../../../components/Operations/styled/OperationButtonContained"
import OperationButtonOutlined from "../../../components/Operations/styled/OperationButtonOutlined"
import OperationTextGrid from "../../../components/Operations/styled/OperationTextGrid"
import OperationTypographyInstruction from "../../../components/Operations/styled/OperationTypographyInstruction"
import OperationTypographyText from "../../../components/Operations/styled/OperationTypographyText"
import { IOperationsStatus, ModalityType } from "../../../types/FaceVerification"
import OperationTypographyLabelText from "../../../components/Operations/styled/OperationTypographyLabelText"

interface IEnrollSideBar {
    subjectId: string
    checkState: IOperationsStatus
    activeModality: ModalityType | null
    start: () => void
    cancel?: () => void
    restart: () => void
}

const EnrollSideBar: React.FC<IEnrollSideBar> = (props) => {

    const state = useContext(AppContext).state
    const history = useHistory()
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    const handleSubjectId = () => {
        if (state.prefix) {
            if (props.subjectId.startsWith(state.prefix)) {
                return props.subjectId.substring(state.prefix.length + 1)
            }
        }
        return props.subjectId;
    }

    const getButtons = () => {
        if (props.activeModality === ModalityType.OVERVIEW) {
            return (
                <OperationButtonContained onClick={() => history.push("/")} color="primary" variant="contained">
                    Finish
                </OperationButtonContained>
            )
        }
        switch(props.checkState) {
            case IOperationsStatus.IDLE:
                return (
                    <OperationButtonContained onClick={props.start} color="primary" variant="contained">
                        Start enroll
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.ACTIVE:
                return (
                    <OperationButtonContained onClick={props.cancel} color="primary" variant="contained">
                        Cancel
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.DONE:
                return (
                    <>
                        <OperationButtonContained onClick={props.restart} color="primary" variant="contained">
                            Restart enroll
                        </OperationButtonContained>
                        <OperationButtonOutlined color="primary" variant="outlined" onClick={() => {history.push("/")}}>
                            Home
                        </OperationButtonOutlined>
                    </>
                )
        }
    }

    const getModalityText = () => {
        switch(props.activeModality) {
            case ModalityType.FACE_MODALITY:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Take a selfie
                                </OperationTypographyInstruction>
                                <OperationTypographyLabelText>
                                    Adjust your position to place your face into oval frame and press <b>Start enroll</b>.
                                </OperationTypographyLabelText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
            case ModalityType.VOICE_MODALITY:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Record your voice
                                </OperationTypographyInstruction>
                                <OperationTypographyLabelText>
                                    Press <b>Start enroll</b> and speak.
                                </OperationTypographyLabelText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
            case ModalityType.OVERVIEW:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Preview captured data
                                </OperationTypographyInstruction>
                                <Tooltip title={handleSubjectId()} enterDelay={1000} enterNextDelay={1000}>
                                    <OperationTypographyText>
                                        <b>SubjectId:</b><br/> {handleSubjectId()} 
                                    </OperationTypographyText>
                                </Tooltip>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
        }
    }

    return (
        <OperationTextGrid item md={2} xs={12} glow={(props.checkState !== IOperationsStatus.ACTIVE && isMobile)}>
            {getModalityText()}
        </OperationTextGrid>
    )
}

export default EnrollSideBar